export default "__VITE_ASSET__2VcC4LJ5__"